import React from "react";
import { FormRenderer } from "../form-fields/form-render/form-renderer";
import { Button } from "../ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
} from "../ui/sheet";

export const DrawerForm = ({
  title,
  fields,
  values,
  onFieldChange,
  onFieldBlur = () => {},
  onCancel,
  onSubmit,
  footerButtons,
  isOpen = false,
  componentContext = {},
  customClasses = {},
}) => {
  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <SheetContent
        side="right"
        className="w-full md:w-1/2 lg:w-1/2 xl:w-2/5 sm:max-w-none flex flex-col h-full p-0 bg-primary-7"
      >
        {/* Header */}
        <SheetHeader className="p-5 border-b border-neutral-5 bg-primary-5 text-left">
          <SheetTitle className="text-xl font-semibold text-neutral-12">
            {title}
          </SheetTitle>
        </SheetHeader>

        {/* Form Content */}
        <div className="flex-1 overflow-y-auto p-5 bg-primary-7">
          <div className="-mx-2 flex flex-wrap">
            {fields.map((item) => (
              <FormRenderer
                key={item.uniqueField}
                item={item}
                fieldValue={values[item.uniqueField]}
                onFieldBlur={onFieldBlur}
                onFieldChange={onFieldChange}
                componentContext={componentContext}
                customClasses={customClasses}
              />
            ))}
          </div>
        </div>

        {/* Footer */}
        <SheetFooter className="border-t border-neutral-5 p-5 flex-row justify-end space-x-3 bg-white">
          <Button
            variant="outline"
            onClick={onCancel}
            className="px-6 bg-transparent border-neutral-5 text-neutral-10 hover:bg-neutral-3 min-w-[120px]"
          >
            {footerButtons.cancelLabel}
          </Button>
          <Button
            variant="primary"
            onClick={onSubmit}
            className="min-w-[120px]"
          >
            {footerButtons.submitLabel}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};
